import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsGraphHistoryUndo;
(function (NsGraphHistoryUndo) {
    /** Command: 用于注册named factory */
    NsGraphHistoryUndo.command = XFlowGraphCommands.GRAPH_HISTORY_UNDO;
    /** hookName */
    NsGraphHistoryUndo.hookKey = 'historyUndo';
})(NsGraphHistoryUndo || (NsGraphHistoryUndo = {}));
let GraphHistoryUndoCommand = class GraphHistoryUndoCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.historyUndo.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const graph = yield ctx.getX6Graph();
                if (graph.isHistoryEnabled() === false) {
                    return {
                        err: 'history is disabled',
                    };
                }
                graph.undo();
                ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                    const { commandService } = handlerArgs;
                    commandService.executeCommand(XFlowGraphCommands.GRAPH_HISTORY_REDO.id, {});
                })));
                return { err: null };
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphHistoryUndoCommand.prototype, "contextProvider", void 0);
GraphHistoryUndoCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphHistoryUndo.command.id },
    })
    /** 开启history命令 */
], GraphHistoryUndoCommand);
export { GraphHistoryUndoCommand };
//# sourceMappingURL=graph-history-undo.js.map